import getCalendarSharingCalendars from '../data/selectors/getCalendarSharingCalendars';
import getCalendarSharingCurrentState from '../data/selectors/getCalendarSharingCurrentState';
import getCalendarSharingInitialState from '../data/selectors/getCalendarSharingInitialState';

/**
 * Checks shared calendar options store for changes
 * @returns true if there are changes in the current state, false otherwise.
 */
export default function isSharedCalendarsOptionDirty(): boolean {
    const currentState = getCalendarSharingCurrentState();
    const initialState = getCalendarSharingInitialState();
    const calendars = getCalendarSharingCalendars();
    for (let i = 0; i < calendars.length; i++) {
        let folderId = calendars[i].folderId;
        if (
            initialState[folderId] != null &&
            currentState[folderId] != null &&
            initialState[folderId] !== currentState[folderId]
        ) {
            return true;
        }
    }
    return false;
}
